export default function initProgressCircle(): void {
  Alpine.data('progressCircle', () => ({
    percent: 0,
    target: 0,
    ready: false,
    animated: false,

    init() {
      this.target = parseInt(this.$root.dataset.target ?? '100', 10);
      this.percent = 0;
      this.ready = false;
      this.animated = false;

      // Intersection Observer to trigger animation when in viewport
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true;
            this.startAnimation();
            observer.disconnect(); // Only animate once
          }
        });
      }, { threshold: 1 }); // 100% visible
      observer.observe(this.$root);
    },

    startAnimation() {
      this.ready = false;
      this.percent = 0;
      this.$nextTick(() => {
        setTimeout(() => {
          this.ready = true;
          const step = () => {
            if (this.percent < this.target) {
              this.percent += 1;
              this.$nextTick(() => {
                setTimeout(step, 10);
              });
            }
          };
          step();
        }, 50); // small delay to ensure initial render
      });
    },

    dasharray() {
      return 2 * Math.PI * 50;
    },

    dashoffset() {
      // If not ready, always show full circumference (hidden)
      if (!this.ready) return this.dasharray();
      return this.dasharray() - (this.percent / 100) * this.dasharray();
    },
  }));
}
